var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    {
      directives: [{ name: "copy-text", rawName: "v-copy-text" }],
      staticClass: "link-txt",
      on: { click: _vm.handleClick },
    },
    [_vm._v(_vm._s(_vm.rowData[_vm.fieldData.fieldCode]))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }